module.exports = function getResource(label, vars = []) {
    const resources = {
        birthdayIconText: 'Cadeau d’anniversaire gratuit',
        earnPointsIconText: 'Accumulez des points par dollar',
        redeemTrialIconText: 'Obtenez des produits et des ensembles en format découverte',
        accessIconText: 'Services beauté offerts en magasin',
        applePaySignIn: 'Ouvrez une session ou créez un compte Sephora pour terminer votre commande avec Apple Pay.',
        pleaseSignInMessage: 'Veuillez ouvrir une session Sephora',
        emailAddressLabel: 'Courriel',
        emailAddressPlaceholder: 'Courriel',
        whatsYourEmailAddressLabel: 'Quelle est votre adresse courriel?',
        signInToSaveBIPointsMessage: 'Ouvrez une session pour enregistrer vos points Beauty Insider et les échanger contre des récompenses gratuites.',
        signInFasterBookingMessage: 'Inscrivez-vous pour réserver plus rapidement et enregistrer votre réservation dans votre compte.',
        haveABIAccountMessage: 'Vous avez un compte Beauty Insider? Utilisez l’adresse courriel avec laquelle vous vous êtes inscrit.',
        notYouMessage: 'Ce n’est pas vous?',
        haveAPasswordMessage: 'Avez-vous un mot de passe sephora.com?',
        imNewMessage: 'Non, c’est la première fois que je visite le site',
        iHaveAPasswordMessage: 'Oui, j’ai un mot de passe',
        passwordLabel: 'Mot de passe',
        testPasswordLabelMobile: 'Mot de passe (de 6 à 12 caractères)',
        passwordPlaceholder: 'Mot de passe',
        enterPasswordErrorMessage: 'Veuillez saisir votre mot de passe.',
        forgotPasswordLink: 'Mot de passe oublié?',
        staySignedInLabel: 'Garder ma session ouverte',
        createAccountLabel: 'Créer votre compte Sephora',
        applePaySephoraAccountAgreement: 'En choisissant « Acheter avec Apple Pay, » vous vous inscrivez sur Sephora.com et vous acceptez notre',
        privacyPolicyLink: 'Politique de confidentialité',
        andText: 'et',
        sephoraTermsOfUse: 'Conditions d’utilisation de Sephora',
        automaticallyEmailsMessage: ' Vous recevrez automatiquement les courriels de Sephora.',
        giftCardsApplePayMessage: 'Les cartes-cadeaux ne peuvent être combinées avec Apple Pay.',
        signInButtonLabel: 'Ouvrir une session',
        buyWithLabel: 'Acheter avec',
        continueButtonLabel: 'Continuer',
        testSignInHeading: 'Ouvrir une session Sephora',
        testNewAccountHeading: 'Nouveau client Sephora?',
        testCreateAccount: 'Créer un compte',
        existingAccountErrorMessage: 'Un compte existe déjà pour l’adresse électronique que vous venez de saisir. Veuillez vous connecter ou choisir une autre adresse courriel.',
        signIn: 'Ouvrir une session',
        showPasswordLinkAriaLabel: 'Montrer le mot de passe',
        hidePasswordLinkAriaLabel: 'Cacher le mot de passe',
        testBiPropLead: 'Inscrivez-vous au programme de fidélisation Beauty Insider pour profiter de récompenses et de privilèges exclusifs :',
        testBiPropGift: 'Recevez un cadeau d’anniversaire gratuit',
        testBiPropPoints: 'Accumulez des points par dollar',
        testBiPropRedeem: 'Échangez vos points pour des produits en format découverte',
        testNewBiPropLead: 'Créez un compte et joignez-vous au programme de fidélisation Beauty Insider gratuitement! Ce programme ouvre la porte aux économies, échantillons et plus.',
        testNewBiPropFree: 'Gratuit',
        testNewBiPropBDayGift: 'Cadeau d’anniversaire',
        testNewBiPropFreeGift: 'Cadeau d’anniversaire gratuit',
        testNewBiPropPoints: 'Économies saisonnières',
        testNewBiPropRedeem: 'Échantillons de récompenses',
        staySignedInTooltip: 'En sélectionnant cette option, vous n’aurez pas à ouvrir de session aussi souvent sur cet appareil. Pour votre sécurité, nous vous recommandons de le faire uniquement sur vos appareils personnels.',
        signInToSaveAndRedeemBiPoints1: 'Ouvrez une session et passez à la caisse pour enregistrer vos',
        signInToSaveAndRedeemBiPoints2: `${vars[0]} points Beauty Insider`,
        signInToSaveAndRedeemBiPoints3: 'et les échanger pour des récompenses gratuites.'
    };

    return resources[label];
};
